// extracted by mini-css-extract-plugin
module.exports = {"header":"AccreditationHeader_header__wxkCG","group":"AccreditationHeader_group__2EobZ","cancel":"AccreditationHeader_cancel__1DggE","title":"AccreditationHeader_title__2tIOM"};